// extracted by mini-css-extract-plugin
export var program = "program-module--program--XQTTX";
export var programContentWrapper = "program-module--program-content-wrapper--Wqx6l";
export var programContent = "program-module--program-content--st0Rd";
export var programImage = "program-module--program-image--tKmPe";
export var programBtn = "program-module--program-btn--k1N6G";